
export enum CacheType {
    SessionStorage,
    LocalStorage,
    IndexedDB
}
